<template>
  <div
    :id="uid"
    :style="getStartPosition_"
    class="floating-button"
    @mousedown.stop="itemClick"
  >
    <div class="btn" :style="getBtnStyle_">
      <cnd-icon
        :class="show ? 'roate' : ''"
        :style="getIconStyle_"
        :name="icon"
        color="blue"
      ></cnd-icon>
    </div>
    <div :style="getSubStyle_" class="sub">
      <div v-show="show" :class="['sub-content', direction]">
        <slot name="default">
          <cnd-icon
            v-for="(item, index) in list"
            :key="index"
            :name="item.name"
            :color="item.color"
            @click="clickIcon(item)"
          ></cnd-icon>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import { getUId, addUnit } from '../util'
export default {
  name: 'FloatingButton',
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    bgColor: {
      type: String,
      default: '#fff'
    },
    autoHide: {
      type: Boolean,
      default: true
    },
    clickDis: {
      type: Number,
      default: 10
    },
    showWidth: {
      type: Number,
      default: 15
    },
    size: {
      type: Number,
      default: 80
    },
    // width: {
    //   type: Number,
    //   default: 80
    // },
    // height: {
    //   type: Number,
    //   default: 80
    // },
    // radius: {
    //   type: Boolean,
    //   default: true
    // },
    radius: {
      type: String,
      default: '50%'
    },
    btnStyle: {
      type: Object,
      default: () => {}
    },
    iconStyle: {
      type: Object,
      default: () => {
        return {
          fontSize: '30px',
          color: '#0065d9'
        }
      }
    },
    icon: {
      type: String,
      default: 'cnd-plus'
    },
    zIndex: {
      type: Number,
      default: 999
    },
    position: {
      type: Object,
      default: () => {
        return {
          x: '80%',
          y: '85%'
        }
      }
    },
    direction: {
      type: String,
      default: 'horizontal' // 'vertical'
    },
    modal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      startX: '',
      startY: '',
      clickStatus: false,
      isClick: true,
      dom: null,
      show: false,
      startTime: 0,
      subDom: null,
      isClickContent: false
    }
  },

  computed: {
    uid() {
      return getUId() + 'floating-button-btn'
    },
    getStartPosition_() {
      const x = this.position.x
      const y = this.position.y
      const left = `left:${x};`
      const top = `top:${y};`
      const index = `z-index:${this.zIndex};`
      return left + top + index
    },
    getBtnStyle_() {
      const style = {
        width: addUnit(this.size),
        height: addUnit(this.size),
        lineHeight: addUnit(this.size),
        zIndex: this.zIndex
      }
      if (this.radius) {
        style.borderRadius = this.radius
      }
      if (this.bgColor) {
        style.backgroundColor = this.bgColor
      }
      const btnStyle = this.btnStyle
      for (const k in btnStyle) {
        style[k] = btnStyle[k]
      }
      return style
    },
    getIconStyle_() {
      const res = {}
      const btnStyle = this.iconStyle
      for (const k in this.iconStyle) {
        res[k] = btnStyle[k]
      }
      return res
    },
    getSubStyle_() {
      const style = {
        width: addUnit(this.size),
        height: addUnit(this.size),
        paddingLeft: addUnit(this.size)
      }
      if (this.radius) {
        style.borderRadius = addUnit(this.size)
      }
      if (this.direction === 'vertical') {
        style.transform = `rotate(-90deg)`
        const origin = Number(this.size) / 2
        style.transformOrigin = `${origin}px ${origin}px`
      } else {
        style.transform = `rotate(0deg)`
        style.transformOrigin = ``
      }
      return style
    }
  },
  mounted() {
    this.preventEvent()
    window.addEventListener('mouseup', this.handleMouseup)
    window.addEventListener('mousemove', this.handleMouseover)
    this.dom = document.getElementById(this.uid)
    this.subDom = this.dom.querySelector('.sub')
  },
  methods: {
    clickIcon(i) {
      this.$emit('clickItem', i)
    },
    async clickbtn() {
      if (this.isClickContent) {
        this.isClickContent = false
        return
      }
      this.$emit('click')
      if (this.$slots.default && this.$slots.default.length || this.list.length) {
        const sub = this.subDom
        if (!this.show) {
          let width = this.size
          if (this.$slots.default?.length) {
            width = this.$slots.default.length * this.size + this.size
          } else if (this.list.length) {
            width = this.list.length * this.size + this.size
          }
          sub.style.width = addUnit(width)
          this.show = true
          if (this.modal) {
            const div = document.createElement('div')
            div.className = 'v-modal'
            div.style.zIndex = this.zIndex - 1
            document.body.append(div)
          }
        } else {
          if (this.modal) {
            document.querySelector('.v-modal').remove()
          }
          sub.style.width = addUnit(this.size)
          this.show = false
        }
      }
    },

    // 阻止默认事件
    preventEvent() {
      document.getElementById(this.uid).ondragstart = function() {
        return false
      }
      document.getElementById(this.uid).onselectstart = function() {
        return false
      }
    },
    windowPreventEvent() {
      window.ondragstart = function() {
        return false
      }
      window.onselectstart = function() {
        return false
      }
    },
    windowPreventEventCancel() {
      window.ondragstart = null
      window.onselectstart = null
    },
    itemClick(event) {
      const cName = event.target.className
      if (
        cName &&
        typeof cName === 'string' &&
        cName.indexOf('sub-content') !== -1
      ) {
        this.isClickContent = true
      } else {
        let parent = event.target.parentNode
        while (parent) {
          if (parent && parent.className === 'floating-button') {
            this.isClickContent = false
            break
          }
          if (
            parent &&
            typeof parent.className === 'string' &&
            parent.className.indexOf('sub-content') !== -1
          ) {
            this.isClickContent = true
            break
          }
          parent = parent.parentNode
        }
      }
      this.startTime = Date.now()
      this.startX = event.pageX - window.scrollX
      this.startY = event.pageY - window.scrollY
      this.clickStatus = true
      this.windowPreventEvent()
    },
    // 鼠标抬起时
    handleMouseup(event) {
      if (Date.now() - this.startTime < 200) {
        this.clickbtn()
        this.clickStatus = false
        // this.isClick = true
        // this.windowPreventEventCancel()
        return
      }
      if (this.clickStatus && !this.isClickContent) {
        const endX = event.pageX - window.scrollX
        if (this.isClick) {
          this.$emit('hoverBtnClick')
        } else {
          if (!this.autoHide) return
          const width = document.body.offsetWidth
          if (endX < this.size / 2) {
            this.dom.style.left = addUnit(-(this.size - this.showWidth))
          } else if (endX > width - this.size / 2) {
            this.dom.style.left = addUnit(width - this.showWidth)
          }
        }
        this.clickStatus = false
        this.isClick = true
        this.windowPreventEventCancel()
      }
    },

    handleMouseover(event) {
      if (this.clickStatus && !this.isClickContent) {
        const endX = event.pageX - window.scrollX
        const endY = event.pageY - window.scrollY
        if (
          Math.abs(endX - this.startX) > this.clickDis ||
          Math.abs(endY - this.startY) > this.clickDis
        ) {
          this.isClick = false
        }
        this.dom.style.left = addUnit(endX - this.size / 2)
        this.dom.style.top = addUnit(endY - this.size / 2)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.floating-button {
  cursor: pointer;
  position: fixed;
  user-select: none;

  .btn {
    // border-radius: 50%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border-width: 0;
    box-shadow: 0 1px 5px 2px rgb(0 0 0 / 30%);
  }

  .cnd-icon {
    transition: all 0.2s;
  }

  .roate {
    transform: rotate(45deg);
  }

  .sub {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    background: #fff;
    border-width: 0;
    box-shadow: 0 1px 5px 2px rgb(0 0 0 / 30%);
    transition: all 0.2s;

    &-content {
      display: flex;
      justify-content: space-around;
      align-items: center;
      height: 100%;

      &.vertical {
        * {
          transform: rotate(90deg);
        }
      }
    }
  }
}
</style>
